import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// import type { Pokemon } from "./types";

// Define a service using a base URL and expected endpoints
export const chatApi = createApi({
  reducerPath: "chatApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL_USER_DATA}/`,
  }),
  tagTypes: ["allRooms"],
  endpoints: (builder) => ({
    getAllRooms: builder.query<any, any>({
      query: (idUser) => {
        return {
          url: `talk/getAllRooms?actor1=${idUser}`,
          method: "GET",
        };
      },
      providesTags: ["allRooms"],
    }),
    findRoom: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: `talk/findRoom`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["allRooms"],
    }),
    getConversation: builder.mutation<any, any>({
      query: (body) => ({
        url: `conversation/getConversation`,
        method: "POST",
        body,
      }),
    }),
    sendMessage: builder.mutation<any, any>({
      query: (body) => ({
        url: `talk/sendMessage`,
        method: "POST",
        body,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllRoomsQuery,
  useFindRoomMutation,
  useGetConversationMutation,
  useSendMessageMutation,
} = chatApi;
